<script setup lang="ts">
import BaseIconLoader from '@/presentation/components/base/iconLoader/BaseIconLoader.vue';

interface IProps {
	routeAddress: string;
	activeRouteName: string;
	routeName: string;
	label: string;
	iconName: string;
	customRuleActivation?: boolean;
}

const props = defineProps<IProps>();

const isActiveRoute = computed(() => props.customRuleActivation ?? props.activeRouteName === props.routeName);

const activeClassModifier = computed(() => (isActiveRoute.value ? 'bg-primary-gradient text-white' : 'bg-[#F5F5F8] text-black'));
</script>

<template>
	<RouterLink :to="routeAddress" class="p-2 mx-8 my-1 fade-animation rounded-lg" :class="activeClassModifier">
		<div class="flex items-center p-2 gap-2">
			<BaseIconLoader :name="iconName" size="26px" :fill="isActiveRoute ? 'white' : 'black'" />
			<span class="text-sm pl-1 mt-1"> {{ label }} </span>
		</div>
	</RouterLink>
</template>
